export const CenterServiceType = {
    LANGUAGE: "언어",
    ART: "미술",
    PSYCHOLOGY: "심리",
} as const;

export const CenterUserStatus = {
    PENDING: "대기",
    ACCEPTED: "승인",
    REJECTED: "반려",
    CANCELED: "취소",
    LEFT: "탈퇴",
} as const;

export const CenterJoinStatus = {
    PENDING: "대기",
    ACCEPTED: "승인",
    REJECTED: "반려",
    CANCEL: "취소",
} as const;

export const CenterInviteStatus = {
    MESSAGE_SENT: "대기",
    ACCEPTED: "승인",
    REJECTED: "반려",
    CANCELED: "취소",
} as const;

export const TherapyArea = {
    LANGUAGE: "언어",
    HEARING: "청능",
    ART_MUSIC: "미술,음악",
    BEHAVIOR_PLAY_PSYCHOLOGY: "행동,놀이,심리",
    SENSORY_MOVEMENT: "감각,운동",
    ETC: "기타",
} as const;

export const UseVoucher = {
    YES: "가능",
    NO: "불가능",
    CENTER_ASK: "센터 문의",
} as const;

export const BusinessType = {
    FREELANCER: "프리랜서",
    BUSINESS: "사업자",
} as const;

export const CenterLogCategory = {
    캘린더: "캘린더",
    아동업무: "아동업무",
    검사도구: "검사도구",
    치료업무: "치료업무",
    센터관리: "센터관리",
    수납관리: "수납관리",
    행정관리: "행정관리",
} as const;
